/* eslint-disable */
import { mutations } from './mutations';
import { getters } from './getters';
import { actions } from './actions';
import { LogState } from './state';

const defaultState: LogState = {
  logString: "",
};

export const logModule = {
  state: defaultState,
  mutations,
  actions,
  getters,
};
